import { router } from "../../router";
import { useAccessStore } from "../store/useAccessStore";

interface DeepLinkData {
  path: string;
}

declare global {
  interface Window {
    handleDeepLink: (data: DeepLinkData | string) => void;
  }
}

const APP_OPEN_PATH = "/app-open";

/**
 * 딥링크 path를 실제 이동 경로로 변환한다.
 * /app-open(쿼리 포함) 으로 들어오면 로그인 여부에 따라 인터셉트:
 *   - 로그인 O → 홈(/)
 *   - 로그인 X → 회원가입(/signup)
 */
function resolveTargetPath(path: string): string {
  const pathname = path.split(/[?#]/)[0];

  // /app-open 진입 시 처리
  if (pathname === APP_OPEN_PATH) {
    const isAuthed = useAccessStore.getState().isAuthenticated();
    if (!isAuthed) return "/signup";

    // 로그인 상태면 url 쿼리 파라미터가 있으면 그쪽으로, 없으면 홈
    const url = new URL(path, window.location.origin);
    const target = url.searchParams.get("url");
    if (target) {
      return target.startsWith("/") ? target : `/${target}`;
    }
    return "/";
  }

  return path;
}

window.handleDeepLink = (data: DeepLinkData | string): void => {
  try {
    const parsed: DeepLinkData =
      typeof data === "string" ? JSON.parse(data) : data;
    if (parsed.path) {
      router.navigate(resolveTargetPath(parsed.path));
    }
  } catch (error) {
    console.error(error, "handleDeepLink 오류");
  }
};

export {};
